import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ApplyFormService} from "../../../../shared/services/apply-form.service";
import {AlertService} from "../../../../shared/services/alert.service";
import {ContactUsService} from "../../../../shared/services/contact-us.service";

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {
    applyNowForm: FormGroup = new FormGroup({});
    formSubmitted = false;
    pcbMappings: any = [];
    programs: any = [];
    courses: any = [];
    branches: any = [];
    showCourseDropdown = false;
    showBranchDropdown = false;
    filteredMappingCourses: any  [];
    filteredBranches: any = [];
    selectedBranchData: any;
    searchForm: FormGroup = new FormGroup({});
    filteredBranch: any[] = [];
    filteredCourses: any [] = [];
    contacts = [
        {
            sno: 1,
            office: 'Pathankot',
            owner: 'Rohit',
            contact: '9988854002',
            address: 'Sail Road, Above Axis Bank, Pathankot'
        },
        {
            sno: 2,
            office: 'Mukerian',
            owner: 'Chander Bala',
            contact: '9560455003',
            address: 'Rajendra Place, Mukerian'
        },
        {
            sno: 3,
            office: 'Chamba',
            owner: 'Jodha Mal',
            contact: '8988788906',
            address: 'Near Govt. College, Chamba'
        },
        {
            sno: 4,
            office: 'Kathua',
            owner: 'Kailash Khajuria',
            contact: '8716000091',
            address: 'Opp. DC Office, Kathua'
        },
        {
            sno: 5,
            office: 'Samba',
            owner: 'Hardev Bhagat',
            contact: '9596633454',
            address: 'Opp. Degree College, Ghagwal, Samba'
        },
        {
            sno: 6,
            office: 'Jawali',
            owner: 'Satnam Jassal',
            contact: '8219930518',
            address: 'Kehrian Chowk, Jawali'
        },
        {
            sno: 7,
            office: 'Rehan',
            owner: 'Naresh Kumar',
            contact: '9418361217',
            address: 'Main Bazar, Rehan'
        },
        {
            sno: 8,
            office: 'Nurpur',
            owner: 'Reeta Devi',
            contact: '8894450400',
            address: 'Near Bus Stand, Nurpur'
        },
    ];

    constructor(private formBuilder: FormBuilder,
                private applyFormService: ApplyFormService,
                private alertService: AlertService,
                private contactUsService: ContactUsService,) {
    }

    ngOnInit(): void {
        this.refresh();
    }

    refresh() {
        this.applyNowForm = this.formBuilder.group({
            'name': ['', Validators.required],
            'email': ['', Validators.required],
            'school_id': ['', Validators.required],
            'program_id': ['', Validators.required],
            'course_id': ['', Validators.required],
            'branch_id': [''],
            'selectedCourse': [''],
            'selectedBranch': [''],
            'contact': ['', Validators.required],
        });
        this.getPcb();
        /*  this.contactForm = this.formBuilder.group({
              'name': ['', Validators.required],
              'email': ['', Validators.required],
              'contact': ['', Validators.required],
              'message': ['', Validators.required],

          });*/
    }

    getPcb(): void {
        this.applyFormService.pcb_mapping().subscribe(data => {
            this.pcbMappings = data.data;
            this.programs = data.data;
            this.filteredMappingCourses = this.programs.filter(
                (value, index, self) =>
                    index === self.findIndex((t) => t.course?.name === value?.course?.name)
            );
            // Select "Bachelor of Technology"
            const btechCourse = this.filteredMappingCourses.find(course =>
                course.course?.name?.toLowerCase().includes('bachelor of technology')
            );
            this.filteredMappingCourses.forEach(courseEntry => {
                // Get all entries of this course
                const courseBranches = this.pcbMappings.filter(
                    item => item.course?.id === courseEntry.course?.id
                );

                // Remove duplicate branches for this course
                const uniqueBranches = courseBranches.filter(
                    (value, index, self) =>
                        index === self.findIndex(t => t.branch?.name === value?.branch?.name)
                );

                // Add tuition fee for each unique branch
                uniqueBranches.forEach(branch => {
                    const fees = branch.fees || [];
                    const feeForSession = fees.find(fee => fee?.session_id == 17);
                    branch['tuitionfee'] = parseInt(feeForSession?.tuition_fee) || 0;
                });

                // Store these branches in a new property inside the course
                courseEntry['branches'] = uniqueBranches;
            });
            // Patch selected course (B.Tech)
            if (btechCourse) {
                this.searchForm.patchValue({
                    course_id: btechCourse.course.id
                });
                // Filter branches for selected B.Tech course
                this.filteredBranches = this.pcbMappings.filter(
                    value => value.course?.id === btechCourse.course.id
                );
                this.filteredBranches = this.filteredBranches.filter(
                    (value, index, self) =>
                        index === self.findIndex(t => t.branch?.name === value?.branch?.name)
                );
                // Select "Computer Science Engineering"
                const cseBranch = this.filteredBranches.find(branch =>
                    branch.branch?.name?.toLowerCase().includes('computer science')
                );
                if (cseBranch) {
                    this.searchForm.patchValue({
                        branch_id: cseBranch.branch.id
                    });
                    this.selectedBranchData = cseBranch;
                    this.getFilteredBranchData();
                } else {
                    // If CSE branch not found
                    this.searchForm.patchValue({
                        branch_id: this.filteredBranches[0]?.branch?.id || null
                    });
                }
            }
            // For dropdown population
            this.programs = this.programs.filter(
                (value, index, self) =>
                    index === self.findIndex((t) => t.program?.name === value?.program?.name)
            );
        });
    }

    getCourses(): void {
        this.applyNowForm.patchValue({
            'course_id': null,
            'branch_id': null,
            'selectedCourse': null,
            'selectedBranch': null
        });
        const program = this.applyNowForm?.value?.program_id;

        this.courses = this.pcbMappings.filter(value => value.program?.id == program);
        this.courses = this.courses.filter(
            (value, index, self) =>
                index ===
                self.findIndex((t) => t.course?.name === value?.course?.name)
        );
        this.filteredCourses = this.courses;
        this.filteredCourses = this.filteredCourses;
        const selectedCourseId = this.applyNowForm.value.course_id;
        const courseSchool = this.pcbMappings.find(
            value => value.course?.id == selectedCourseId
        )?.school;

        if (courseSchool) {
            this.applyNowForm.patchValue({
                school_id: courseSchool.id
            });
        }
    }

    getBranches() {
        let schoolId = this.pcbMappings.filter(value => (value.program?.id == this.applyNowForm.value.program_id) && (value.course?.id == this.applyNowForm.value.course_id))[0].school?.id
        this.applyNowForm.patchValue({
            'school_id': schoolId
        })
        const course = this.applyNowForm?.value?.course_id;
        this.branches = this.pcbMappings.filter(value => value.course?.id == course);
        this.branches = this.branches.filter(
            (value, index, self) =>
                index ===
                self.findIndex((t) => t.branch?.name === value?.branch?.name)
        );
        this.filteredBranch = this.branches;
        this.filteredBranch = this.filteredBranch;
    }

    filterCourses(search: string): void {
        this.filteredBranch = this.branches = null;
        this.filteredCourses = this.courses?.filter(c =>
            c?.course?.name?.toLowerCase().includes(search.toLowerCase())
        );
        this.filteredCourses = this.filteredCourses.slice(0, 10);
    }

    selectCourse(course: any): void {
        // this.applyNowForm.get('course_id')?.setValue(course?.course?.id);  // use formControlName
        this.applyNowForm.patchValue({
            'course_id': course?.course?.id,
            'selectedCourse': course?.course?.name,
            'branch_id': '',
            'selectedBranch': '',
        })
        this.filteredCourses = [];
        this.getBranches();
    }

    filterBranch(search: string): void {
        this.filteredBranch = this.branches?.filter(c =>
            c?.branch?.name?.toLowerCase().includes(search.toLowerCase())
        );
    }

    selectBranch(branch: any): void {
        if (branch && branch.branch) {
            this.applyNowForm.patchValue({
                'branch_id': branch?.branch?.id,
                'selectedBranch': branch?.branch?.name
            });
            this.filteredBranch = [];
        }
    }

    getFilteredBranches() {
        const selectedCourseId = this.searchForm?.value?.course_id;

        this.filteredBranches = this.pcbMappings.filter(
            value => value.course?.id == selectedCourseId
        );

        this.filteredBranches = this.filteredBranches.filter(
            (value, index, self) =>
                index === self.findIndex(
                    t =>
                        (t.branch?.name || 'null') === (value.branch?.name || 'null')
                )
        );

        this.searchForm.patchValue({
            branch_id: this.filteredBranches[0]?.branch?.id || null
        });

        this.selectedBranchData = null;
        this.getFilteredBranchData();
    }


    getFilteredBranchData() {
        const selectedCourseId = this.searchForm?.value?.course_id;
        const selectedBranchId = this.searchForm?.value?.branch_id;

        this.selectedBranchData = this.pcbMappings.find(
            item =>
                item.course?.id == selectedCourseId &&
                ((item.branch?.id || null) == (selectedBranchId || null))
        );
    }

    hideDropdownWithDelay(type: any) {
        // Delay hiding to allow click event on dropdown
        if (type == 'COURSE') {
            setTimeout(() => this.showCourseDropdown = false, 150);
        } else if (type == 'BRANCH') {
            setTimeout(() => this.showBranchDropdown = false, 150);
        }
    }

    submit() {
        /* if (!(this.applyNowForm?.valid)) {
             this.alertService.showErrors('All fields are required!');
             return false;
         }*/
        const params = {
            name: this.applyNowForm && this.applyNowForm.getRawValue() && this.applyNowForm.getRawValue().name && this.applyNowForm.getRawValue().name,
            email: this.applyNowForm && this.applyNowForm.getRawValue() && this.applyNowForm.getRawValue().email && this.applyNowForm.getRawValue().email,
            contact: this.applyNowForm && this.applyNowForm.getRawValue() && this.applyNowForm.getRawValue().contact && this.applyNowForm.getRawValue().contact,
            school_id: this.applyNowForm && this.applyNowForm.getRawValue() && this.applyNowForm.getRawValue().school_id && this.applyNowForm.getRawValue().school_id,
            program_id: this.applyNowForm && this.applyNowForm.getRawValue() && this.applyNowForm.getRawValue().program_id && this.applyNowForm.getRawValue().program_id,
            course_id: this.applyNowForm && this.applyNowForm.getRawValue() && this.applyNowForm.getRawValue().course_id && this.applyNowForm.getRawValue().course_id,
            branch_id: this.applyNowForm && this.applyNowForm.getRawValue() && this.applyNowForm.getRawValue().branch_id && this.applyNowForm.getRawValue().branch_id,
        };
        this.applyFormService.add(params).subscribe(data => {
            this.formSubmitted = true;
            this.refresh();
        }, error => {
            if (error && error.error && error.error.errors && error.error.errors['name'] && error.error.errors['name'][0]) {
                this.alertService.showErrors(error.error.errors['name'][0])
            } else if (error && error.error && error.error.errors && error.error.errors['email'] && error.error.errors['email'][0]) {
                this.alertService.showErrors(error.error.errors['email'][0])
            } else if (error && error.error && error.error.errors && error.error.errors['contact'] && error.error.errors['contact'][0]) {
                this.alertService.showErrors(error.error.errors['contact'][0])
            } else if (error && error.error && error.error.errors && error.error.errors['program_id'] && error.error.errors['program_id'][0]) {
                this.alertService.showErrors('Program is Required, Please select a program')
            } else if (error && error.error && error.error.errors && error.error.errors['course_id'] && error.error.errors['course_id'][0]) {
                this.alertService.showErrors('Course is Required, Please select a course')
            } else if (error && error.error && error.error.errors && error.error.errors['branch_id'] && error.error.errors['branch_id'][0]) {
                this.alertService.showErrors('Branch is Required, Please select a branch')
            } else if (error && error.error && error.error.errors && error.error.errors['school_id'] && error.error.errors['school_id'][0]) {
                this.alertService.showErrors('Something went wrong, Please fill again all required fields');
                this.applyNowForm.reset();
            }
        });
    }


    /*  submit() {
          if (!(this.contactForm?.valid)) {
              this.alertService.showErrors('All fields are required!');
              return false;
          }
          const params = {
              'name': this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().name && this.contactForm.getRawValue().name,
              'email': this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().email && this.contactForm.getRawValue().email,
              'contact': this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().contact && this.contactForm.getRawValue().contact,
              'message': this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().message && this.contactForm.getRawValue().message,
          }
          this.contactUsService.create(params).subscribe(data => {
              this.formSubmitted = true;
              this.refresh();
          }, error => {
              if (error && error?.error && error?.error?.errors && error?.error?.errors?.name && error?.error?.errors?.name[0]) {
                  this.alertService.showErrors(error?.error?.errors?.name[0])
              } else if (error && error?.error && error?.error?.errors && error?.error?.errors?.email && error?.error?.errors?.email[0]) {
                  this.alertService.showErrors( error?.error?.errors?.email[0])
              } else if (error && error?.error && error?.error?.errors && error?.error?.errors?.contact && error?.error?.errors?.contact[0]) {
                  this.alertService.showErrors(error?.error?.errors?.contact[0])
              }
          })
      }*/

}
